/**
 * @generated SignedSource<<d7f0b2c611d19b07a0220c2ed273693e>>
 * @relayHash eb2b45b6f1c6a0bf9f3f42710420bd9e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3bfb66bc29f1d4ba518f3f90ceb733bbc250f8984683a642222fe65ede346b9c

import type { ConcreteRequest } from 'relay-runtime';
export type AgentStudioAgentQueryInput = {
  includeDraftAgents?: boolean | null;
  includeJiraCodingAgent?: boolean | null;
  includeRovoChatAgent?: boolean | null;
  name?: string | null;
  onlyEditableAgents?: boolean | null;
  onlyFavouriteAgents?: boolean | null;
  onlyMyAgents?: boolean | null;
  onlyPublishedEditableAgents?: boolean | null;
  onlyPublishedEditableAgentsWithForge?: boolean | null;
  onlyTemplateAgents?: boolean | null;
  onlyUnpublishedAgents?: boolean | null;
  onlyVerifiedAgents?: boolean | null;
};
export type queryAgentMentionsByNameQuery$variables = {
  cloudId: string;
  first?: number | null;
  input?: AgentStudioAgentQueryInput | null;
  product?: string | null;
};
export type queryAgentMentionsByNameQuery$data = {
  readonly agentStudio_getAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
};
export type queryAgentMentionsByNameQuery = {
  response: queryAgentMentionsByNameQuery$data;
  variables: queryAgentMentionsByNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  {
    "kind": "Variable",
    "name": "product",
    "variableName": "product"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "description"
},
v4 = {
  "kind": "ScalarField",
  "name": "picture"
},
v5 = {
  "kind": "ScalarField",
  "name": "identityAccountId"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "queryAgentMentionsByNameQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "identityAccount",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queryAgentMentionsByNameQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "identityAccount",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ]
                  },
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "eb2b45b6f1c6a0bf9f3f42710420bd9e",
    "id": "3bfb66bc29f1d4ba518f3f90ceb733bbc250f8984683a642222fe65ede346b9c",
    "metadata": {},
    "name": "queryAgentMentionsByNameQuery",
    "operationKind": "query",
    "text": "query queryAgentMentionsByNameQuery($cloudId:String!,$first:Int,$input:AgentStudioAgentQueryInput,$product:String){agentStudio_getAgents(cloudId:$cloudId,first:$first,input:$input,product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
  }
};
})();

(node as any).hash = "f44bfcd4dfdb02102d0d5899552fd79b";

export default node;
